import { CONTACT } from "../data/site";
import { trackEvent } from "./analytics";

/**
 * Sends a form to the studio inbox (webstudiosn@gmail.com) via FormSubmit.
 * The first submission triggers a one-time activation email to the inbox.
 */
export async function submitToInbox(formName: string, data: FormData): Promise<boolean> {
  data.append("_subject", `NEXORA website — ${formName}`);
  data.append("_template", "table");
  data.append("_captcha", "false");
  try {
    const res = await fetch(`https://formsubmit.co/ajax/${CONTACT.email}`, {
      method: "POST",
      body: data,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error(String(res.status));
    trackEvent("form_submit", { form: formName });
    return true;
  } catch {
    trackEvent("form_error", { form: formName });
    return false;
  }
}
